import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenericListView } from 'src/app/infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { WrapperStandardFilter, WrapperStandardRequest } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { GenericAutoCompleteView } from 'src/app/infrastructure/infrastructure-services/generics/generic-autocomplete-view/generic-autocomplete-view';
import { FormControl } from '@angular/forms';
import { lastValueFrom, map, Observable, startWith } from 'rxjs';
import { GenericEntryForm } from 'src/app/infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { PaymentChecks, PaymentCreditCards } from 'src/app/core/models/masters/payment-means.model';
import { GlobalProperties } from 'src/app/global/global-properties';
import { HttpClient } from '@angular/common/http';
import { enumErrorMessageText } from 'src/app/infrastructure/infrastructure-services/common/common-enums';
import { ValidationsComponent } from 'src/app/shared/validations/validations.component';

interface Currency {
  code: string,
  name: string,

}
@Component({
  selector: 'app-payment-means',
  templateUrl: './payment-means.component.html',
  styleUrls: ['./payment-means.component.css']
})
export class PaymentMeansComponent extends GenericListView<any> {

  displayedColumns: string[] = ['dueDate', 'country', 'bankName', 'bankBranch', 'accountName',
    'chequeNo', 'amount', 'delete'];

  dataSource = [];
  local_data: any;
  genAutoComplete = new GenericAutoCompleteView<any>(this.agenericRepositoryForCfl, this.routerForCfl);
  myControlCurrency = new FormControl<string | Currency>('');
  OptionCurrency: Currency[] = [];
  currencyfilter: Currency[] = [];
  filteredOptionsCurrency!: Observable<Currency[]>;
  currency: string = "";
  getFormDisable: boolean;
  txt = "";
  selectedTabIndex = 0;
  showValidationArr: any;
  constructor(agenericRepository: GenericService<any>, router: Router, public agenericRepositoryForCfl: GenericService<any>,
    public dialog: MatDialog, public matDialogforCfl: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public routerForCfl: Router, public dialogRef: MatDialogRef<any>,
    public matDialogRefForCfl: MatDialogRef<GenericCflViewComponent<any>>, private dbService: NgxIndexedDBService, private http: HttpClient,
    public snackbarService: BaseService<any>) {
    super(agenericRepository, router);
    this.local_data = data.data;


    this.getFormDisable = data.disable;
    if (!this.getFormDisable) {
      this.local_data.balance_due = this.local_data.docTotal;
    }
    if (this.getFormDisable)
      this.local_data.totalPayment = this.local_data.docTotal;
    else
      if (!this.getFormDisable && this.local_data.paymentCreditCards.length == 0) {
        let credit = new PaymentCreditCards();
        this.local_data.paymentCreditCards.push(credit);
      }
    if (this.getFormDisable == true) {
      this.txt = 'Language.OkText';
    }
    else {
      this.txt = 'Language.AddText';
    }
    if (!this.getFormDisable) {
      this.local_data.transferDate = new Date();
      let check = new PaymentChecks();
      check.dueDate = new Date();
      this.local_data.paymentChecks = [...this.local_data.paymentChecks, check];
    }
  }
  maskCardNumber(cardNumber: string): string {
    if (!cardNumber) return '';
    const visibleDigits = 4;
    const maskedSection = cardNumber.slice(0, -visibleDigits).replace(/\d/g, '*');
    const visibleSection = cardNumber.slice(-visibleDigits);
    return maskedSection + visibleSection;
  }
  async ngOnInit() {
    if (!this.local_data.isViewMode) {
      this.local_data.cashSum = 0;
      this.local_data.creditSum = 0;
      this.local_data.checkSum = 0;

      this.local_data.checkAccount = "";
      this.local_data.transferAccount = "";
      this.local_data.transferSum = 0;
      this.local_data.transferSumFC = 0;
      this.local_data.transferAccountName = "";
      this.local_data.transferDate = "";
      this.local_data.totalPayment = 0;
      this.local_data.bankChargeAmount = 0;
      this.local_data.paymentChecks = [];
      //  this.local_data.docTotal = 0;
      let check = new PaymentChecks();
      check.dueDate = new Date();
      this.local_data.paymentChecks = [...this.local_data.paymentChecks, check];



      this.local_data.paymentCreditCards[0].creditSum = 0;
    }
    if (this.getFormDisable == true && this.local_data.paymentCreditCards[0]) {
      let response: any = await lastValueFrom(this.http.get(`${GlobalProperties.getApiUrlSap}IncomingPayments(${this.local_data.docEntry})`, { withCredentials: true }));



      this.local_data.paymentCreditCards[0].creditCardNumber = this.maskCardNumber(response.PaymentCreditCards[0].CreditCardNumber);
    } if (this.getFormDisable) {
      this.myControlCurrency.disable();
    } else {
      this.myControlCurrency.enable();
      const RequestBody = new WrapperStandardRequest();
      RequestBody.RequestData = {
        "BPLName": this.local_data.branchName,
        "CardCode": this.local_data.cardCode

      }

      const ListResponse = await lastValueFrom(this.agenericRepositoryForCfl.PostAPI(GlobalProperties.getApiUrl + 'IncomingPayments/GetAccountDetails', RequestBody));

      this.local_data.paymentChecks[0].branch = ListResponse.responseData.checkAccount?.branch;
      this.local_data.paymentChecks[0].bankName = ListResponse.responseData.checkAccount?.bankName;
      this.local_data.paymentChecks[0].bankCode = ListResponse.responseData.checkAccount?.bankCode;
      this.local_data.paymentChecks[0].countryCode = ListResponse.responseData.checkAccount?.country;
      this.local_data.paymentChecks[0].countryName = ListResponse.responseData.checkAccount?.countryName;
      this.local_data.paymentChecks[0].accounttNum = ListResponse.responseData.checkAccount?.accountCode;
      this.local_data.checkAccount = ListResponse.responseData.checkAccount?.defaultChequeAccountAtHeader;
      this.local_data.checkAccountName = ListResponse.responseData.checkAccount?.defaultChequeAccountNameAtHeader;
      this.local_data.transferAccount = ListResponse.responseData.bankTransferAccount?.accountCode;
      this.local_data.transferAccountName = ListResponse.responseData.bankTransferAccount?.accountName;
      this.local_data.cashAccount = ListResponse.responseData.cashAccount?.accountCode;
      this.local_data.cashAccountName = ListResponse.responseData.cashAccount?.accountName;
      this.local_data.paymentCreditCards.creditCard = ListResponse.responseData.creditCardAccount?.creditCardName;
      this.local_data.paymentCreditCards.creditAcct = ListResponse.responseData.creditCardAccount?.accountCode;
    }

    this.getIntialAPIListForCurrency();

    this.filteredOptionsCurrency = this.myControlCurrency.valueChanges.pipe(
      startWith(''),
      map(value => {
        const code = typeof value === 'string' ? value : value?.code;
        return code ? this._filterCurrency(code as string) : this.OptionCurrency.slice();
      }),
    );

    if (this.getFormDisable) {
      if (this.local_data.paymentChecks.length != 0) {
        this.selectedTabIndex = 0;
      } else if (this.local_data.transferSum != 0) {
        this.selectedTabIndex = 1;
      }
      else if (this.local_data.cashSum != 0) {
        this.selectedTabIndex = 2;
      }
      else if (this.local_data.paymentCreditCards.length != 0) {
        this.selectedTabIndex = 3;
      }
    }


  }

  onChangeAmount() {
    let amount = 0;
    this.local_data.totalPayment = 0;
    this.local_data.balance_due = this.local_data.docTotal;
    if (this.local_data.paymentChecks) {
      this.local_data.checkSum = this.local_data.paymentChecks.reduce((sum: number, item: any) => { return sum + item.checkSum }, 0);
    }//amount =this.local_data.paymentChecks.reduce((amount:number, item:any) => amount + ( item.checkSum ), 0);
    if (this.local_data.paymentCreditCards[0].creditSum) {
      this.local_data.creditSum = this.local_data.paymentCreditCards[0].creditSum;
    }
    if (this.local_data.cashSum) { amount += this.local_data.cashSum; }
    if (this.local_data.creditSum) { amount += this.local_data.creditSum; }
    if (this.local_data.transferSum) { amount += this.local_data.transferSum; }
    if (this.local_data.checkSum) { amount += this.local_data.checkSum; }

    this.local_data.totalPayment = amount;
    this.local_data.balance_due -= amount;
    //this.local_data.balance_due=this.local_data.docTotal- this.local_data.totalPayment;


  }


  onChange(value: string) {

  }


  async getIntialAPIListForCurrency() {
    this.genAutoComplete.setACDataSourceURL = 'CurrenciesSetUp/GetCurrenciesSetUpListService';
    this.genAutoComplete.setACSortColumn = "name";
    let result = await this.genAutoComplete.onClickOptionsList();
    result.forEach((element: any) => {
      this.OptionCurrency.push({ 'name': element.name, 'code': element.code });
    })
    console.log(result);
  }


  private _filterCurrency(code: string): Currency[] {

    const filterValue = code.toLowerCase();
    return this.OptionCurrency.filter(option => option.code.toLowerCase().includes(filterValue));
  }
  async callApi() {

    let response: any = await lastValueFrom(this.http.get(`${GlobalProperties.getApiUrlSap}IncomingPayments(${this.local_data.docEntry})`, { withCredentials: true }));

    this.local_data.paymentCreditCards[0].creditCardNumber = response.PaymentCreditCards[0].CreditCardNumber;


  }



  OnOptionSelectedCurrency(option: Currency) {
    this.currency = option.code;
    // this.subjectname = option;
    // this.subjectcode = option ? option.code : null;
    // this.getEntryFormDataSource.subject = this.code;
  }
  cancel() {
    this.local_data = "";
    this.local_data.cashAccount = "";
    this.local_data.cashAccountName = "";
    this.local_data.cashSum = 0;
    this.local_data.creditSum = 0;
    this.local_data.checkSum = 0;

    this.local_data.checkAccount = "";
    this.local_data.transferAccount = "";
    this.local_data.transferSum = 0;
    this.local_data.transferSumFC = 0;
    this.local_data.transferAccountName = "";
    this.local_data.transferDate = "";

    this.local_data.bankChargeAmount = 0;

    this.local_data.docTotal = 0;


    this.local_data.paymentChecks = [];

    this.local_data.paymentCreditCards = [];
  }
  save() {
    if (this.local_data.totalPayment < 0) {
      this.showValidationArr = [enumErrorMessageText.PaymentNegative];
      let filterDialogRef = this.dialog.open(ValidationsComponent, {
        // height: '100%',
        width: '400px',
        panelClass: 'validatesection',
        position: { right: 0 + 'px', top: 56 + 'px' },
        data: {
          showValidation: this.showValidationArr,
          title: "Payment Means"
        }
      });
      filterDialogRef.afterClosed().subscribe((res: any) => {

      });

      return;
    }
    this.local_data.paymentChecks.forEach((el: any, index = 0) => {
      if (el.checkSum == 0)
        this.local_data.paymentChecks.splice(index, 1)
      index++;
    })

    this.local_data.isViewMode = true;
    this.dialogRef.close({ event: true, value: this.local_data });
  }

  async onOpenDropDown(value: any, id: number) {

    if (this.getFormDisable) {
      return
    }
    let filter: WrapperStandardFilter = new WrapperStandardFilter();
    let genCFL = new GenericCflViewComponent<any>(this.agenericRepositoryForCfl, this.routerForCfl, this.matDialogforCfl, this.matDialogRefForCfl, this.data, this.dbService);


    if (value == 2) {
      genCFL.setCflTitle = "Currency";
      genCFL.setIsCflSingleSelection = true;
      genCFL.setCflViewDataSourceURL = 'CurrenciesSetUp/GetCurrenciesSetUpListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      // genCFL.setCflSelectedData = this.getEntryFormDataSource.currencyName;
      genCFL.setSortColumn = "name";

    }

    else if (value == "accountType") {
      genCFL.setCflTitle = "Account Type";
      genCFL.setIsItCflEnumList = true;
      genCFL.setCflEnumStoreName = 'ChartOfAccountForm';
      // genCFL.setCflEnumDataToStoreInDB = this.getEntryFormDataSource.enumData;
      genCFL.setCflEnumObjectNameToDisplay = 'accountType';
      genCFL.setCflDisplayedColumnsNamesList = ['description'];
      genCFL.setSortColumn = "value";
      //   genCFL.setCflSelectedData = this.getEntryFormDataSource.accountType;
    }
    else if (value == 1) {
      genCFL.setCflTitle = "Account Name";
      genCFL.setIsCflSingleSelection = true;
      genCFL.setCflViewDataSourceURL = 'ChartOfAccounts/GetChartOfAccountsListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      //  genCFL.setCflSelectedData = this.getEntryFormDataSource.fatherAccountName;
      genCFL.setSortColumn = "name";
      filter.Key = 'activeAccount';
      filter.OperatorType = 'contains';
      filter.Value = "Y"
      genCFL.setCflFilterArray = filter;
    }
    else if (value == 'checkAccount') {
      genCFL.setCflTitle = "Account Name";
      genCFL.setIsCflSingleSelection = true;
      genCFL.setCflViewDataSourceURL = 'IncomingPayments/CustomerWiseAccount';
      genCFL.setCflDisplayedColumnsNamesList = ['bankCode', 'bankName', 'branch', 'accountCode'];
      //  genCFL.setCflSelectedData = this.getEntryFormDataSource.fatherAccountName;
      genCFL.setSortColumn = "cardCode";
      filter.Key = 'cardCode';
      filter.OperatorType = 'startsWith';
      filter.Value = this.local_data.cardCode;
      genCFL.setCflFilterArray = filter;
      let filter2 = new WrapperStandardFilter();
      filter2.Key = 'cardCode';
      filter2.OperatorType = 'endsWith';
      filter2.Value = this.local_data.cardCode;
      genCFL.setCflFilterArray = filter2;
    }
    else if (value == 'accountBank') {
      genCFL.setCflTitle = "Account Name";
      genCFL.setIsCflSingleSelection = true;
      genCFL.setCflViewDataSourceURL = 'ChartOfAccounts/GetChartOfAccountsListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      //  genCFL.setCflSelectedData = this.getEntryFormDataSource.fatherAccountName;
      genCFL.setSortColumn = "name";
      filter.Key = 'activeAccount';
      filter.OperatorType = 'contains';
      filter.Value = "Y"
      genCFL.setCflFilterArray = filter;
    }
    else if (value == 'cashAccount') {
      genCFL.setCflTitle = "Account Name";
      genCFL.setIsCflSingleSelection = true;
      genCFL.setCflViewDataSourceURL = 'ChartOfAccounts/GetChartOfAccountsListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      //  genCFL.setCflSelectedData = this.getEntryFormDataSource.fatherAccountName;
      genCFL.setSortColumn = "name";
      filter.Key = 'activeAccount';
      filter.OperatorType = 'contains';
      filter.Value = "Y"
      genCFL.setCflFilterArray = filter;
    }
    else if (value == 'country') {
      genCFL.setCflTitle = "Country";
      // genCFL.setCflViewDataSourceURL = 'Country/GetCountryListService';
      genCFL.setCflViewDataSourceURL = 'IncomingPayments/CustomerWiseCountry';
      genCFL.setCflDisplayedColumnsNamesList = ['country', 'countryName'];
      filter.Key = 'cardCode';
      filter.OperatorType = 'startsWith';
      filter.Value = this.local_data.cardCode
      genCFL.setCflFilterArray = filter;
      let filter2 = new WrapperStandardFilter();
      filter2.Key = 'cardCode';
      filter2.OperatorType = 'endsWith';
      filter2.Value = this.local_data.cardCode;
      genCFL.setCflFilterArray = filter2;
      //   genCFL.setCflSelectedData = this.getEntryFormDataSource.bpAddresses[this.indexAddress].countryName;
      genCFL.setSortColumn = "cardCode";


    }
    if (value == 'BPCode') {
      genCFL.setCflTitle = "BP Details";
      genCFL.setCflViewDataSourceURL = 'BusinessPartner/GetBusinessPartnerListService';
      genCFL.setCflDisplayedColumnsNamesList = ['cardCode', 'cardName'];
      //  genCFL.setCflSelectedData = this.cardCode;
      genCFL.setSortColumn = "cardCode";
    }

    if (value == 'BPLName') {
      genCFL.setCflTitle = "Branch Details";
      genCFL.setCflViewDataSourceURL = 'Branch/GetBranchListService';
      genCFL.setCflDisplayedColumnsNamesList = ['branchName'];
      //genCFL.setCflSelectedData = this.getEntryFormDataSource.branchName;
      genCFL.setSortColumn = "branchName";

      filter.Key = 'disabled';
      filter.OperatorType = 'contains';
      filter.Value = 'N'
      genCFL.setCflFilterArray = filter;
    }
    if (value == 'Series') {
      genCFL.setCflTitle = "Series Detalis";
      genCFL.setCflViewDataSourceURL = 'DocumentNumberingSetup/GetDocumentNumberingSetupListService';
      genCFL.setCflDisplayedColumnsNamesList = ['series', 'name'];
      // genCFL.setCflSelectedData = this.getEntryFormDataSource.seriesName
      genCFL.setSortColumn = "name";
      filter.Key = 'document';
      filter.OperatorType = null;
      filter.Value = '24';
      genCFL.setCflFilterArray = filter;
      var filter1: WrapperStandardFilter = new WrapperStandardFilter();
      filter1.Key = 'locked';
      filter1.OperatorType = "contains";
      filter1.Value = 'N';
      genCFL.setCflFilterArray = filter1;
    }
    if (value == 'banks') {
      genCFL.setCflTitle = "Banks Details";
      genCFL.setCflViewDataSourceURL = 'Banks/GetBanksListService';
      genCFL.setCflDisplayedColumnsNamesList = ['bankCode', 'bankName', 'countryName'];
      genCFL.setCflSelectedData = this.local_data.paymentChecks[id].bankCode;
      genCFL.setSortColumn = "bankCode";
    }
    if (value == "creditcard") {
      genCFL.setCflTitle = "Credit Card Details";
      genCFL.setCflViewDataSourceURL = "CreditCards/GetCreditCardsListService";
      genCFL.setCflDisplayedColumnsNamesList = ['creditCardName', 'glAccount', 'telephone', 'bankname', 'action'];
      genCFL.setCflSelectedData = this.local_data.paymentCreditCards[0].creditCardName;
      genCFL.setSortColumn = "creditCardName";
    }



    genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
      if (res != undefined && res.event != undefined) {

        if (value == 'BPCode') {
          // this.getEntryFormDataSource.cardCode = res.event.cardCode;
          // this.getEntryFormDataSource.cardName = res.event.cardName;
          // this.getEntryFormDataSource.shipToCode = res.event.shipToDefault;
          // res.event.bpAddresses.forEach((element: any) => {
          //   if (element.addressName == this.getEntryFormDataSource.shipToCode) {
          //     let address = '';
          //     address = element.street + " " + element.city + " " + element.stateName;
          //     this.getEntryFormDataSource.address = address;
          //   }
          // });
        }
        else if (value == "country") {
          this.local_data.paymentChecks[id].countryName = res.event.name;
          this.local_data.paymentChecks[id].countryCode = res.event.code;
        }

        else if (value == 'BPLName') {
          // this.getEntryFormDataSource.bplid = res.event.bplid;
          // this.getEntryFormDataSource.branchName = res.event.branchName;

          // this.getEntryFormDataSource.seriesName=this.OptionSeries.filter(i=>{return  i.bplid==res.event.bplid })[0] == undefined ? "" : this.OptionSeries.filter(i=>{return  i.bplid==res.event.bplid })[0].name;
          //     this.getEntryFormDataSource.series=this.OptionSeries.filter(i=>{return  i.bplid==res.event.bplid })[0] == undefined ? "0" : this.OptionSeries.filter(i=>{return  i.bplid==res.event.bplid })[0].code;

        }
        else if (value == 'Series') {
          //   this.getEntryFormDataSource.series = res.event.series;
          //   this.getEntryFormDataSource.seriesName = res.event.name;
        }
        else if (value == 1) {
          this.local_data.checkAccount = res.event.code;
          this.local_data.checkAccountName = res.event.name;

        }
        else if (value == "banks") {
          this.local_data.paymentChecks[id].bankCode = res.event.bankCode;
          this.local_data.paymentChecks[id].bankName = res.event.bankName;
        }
        else if (value == "checkAccount") {
          this.local_data.paymentChecks[id].accounttNum = res.event.accountCode;
          // this.local_data.paymentChecks[id].checkAccountName= res.event.name;
        }
        else if (value == "accountBank") {
          this.local_data.transferAccount = res.event.code;
          this.local_data.transferAccountName = res.event.name;
        }
        else if (value == "cashAccount") {
          this.local_data.cashAccount = res.event.code;
          this.local_data.cashAccountName = res.event.name;
        }
        else if (value == "creditcard") {
          this.local_data.paymentCreditCards[0].creditCard = 1;
          this.local_data.paymentCreditCards[0].creditCardName = res.event.creditCardName;
          this.local_data.paymentCreditCards[0].creditAcct = res.event.glAccount;
        }



      }
    })
  }

  addCredit() {

    let card = new PaymentCreditCards();
    this.local_data.paymentCreditCards = [...this.local_data.paymentCreditCards, card];

  }
  async addCheck() {
    let check = new PaymentChecks();
    check.dueDate = new Date();
    this.local_data.paymentChecks = [...this.local_data.paymentChecks, check];
    const RequestBody = new WrapperStandardRequest();


  }
  deleteCard(index: number) {

    this.local_data.paymentCreditCards.splice(index, 1);
  }
  deleteCheck(index: number) {

    this.local_data.paymentChecks.splice(index, 1);
    this.local_data.paymentChecks = [...this.local_data.paymentChecks];
  }

}
